containsEverflowTrackingVars